import SetupPaymentMethodModal from "./styles";
export default SetupPaymentMethodModal;

